<template>
    <div class="input-file-component" style="overflow: hidden;">
        <b-overlay :show="refresh" rounded="sm">
            <b-input-group :label-for="uniqueId">

                <b-form-file :id="uniqueId" :name="name" v-model="selectedFiles"
                    :placeholder="file?.originalName || placeholder" :multiple="multiple" :browse-text="browseText"
                    :browse-icon="browseIcon" :drop-placeholder="dropPlaceholder" @change="handleFileChange"
                    :accept="acceptedTypes">
                </b-form-file>

            </b-input-group>
        </b-overlay>
    </div>
</template>

<script>
import BaseButton from '@/components/FormControls/BaseButton.vue';
import { uploadFile } from '@/modules/files/files-upload.service'; // Assuming this service exists
import { msg } from '@/toast';

export default {
    components: { BaseButton },
    name: 'AppInputFile',
    props: {
        label: {
            type: String,
            default: 'Upload File(s)',
        },
        name: {
            type: String,
            default: 'file-upload',
        },
        placeholder: {
            type: String,
            default: 'Choose a file...',
        },
        browseText: {
            type: String,
            default: 'Upload',
        },
        browseIcon: {
            type: String,
            default: 'cloud-upload',
        },
        dropPlaceholder: {
            type: String,
            default: 'Drop file here...',
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        maxSizeMB: {
            type: Number,
            default: 10,
        },
        acceptedTypes: {
            type: String,
            default: '', // e.g., 'image/png, image/jpeg, application/pdf'
        },
        helpText: {
            type: String,
            default: '',
        },
        initialFiles: {
            type: Object,
            default: () => ({})
        },
    },

    data() {
        return {
            selectedFiles: null,
            refresh: false,
            file: {},
            error: null,
            fields: [
                { key: 'label', label: '', class: 'text-left' },
                { key: 'actions', label: '', class: 'text-right' },
            ],
            uniqueId: `file-upload-${Math.random().toString(36).substring(2, 15)}`, // Generate a unique ID
        };
    },

    watch: {
        initialFiles(newFiles) {
            if (newFiles)
                this.file = { ...newFiles };
        },

    },

    methods: {
        truncateMiddle(text, maxLength) {
            if (!text) return '';
            if (text.length <= maxLength) {
                return text;
            }
            const keepLength = Math.floor(maxLength / 2) - 2;
            const start = text.substring(0, keepLength);
            const end = text.substring(text.length - keepLength);
            return `${start}....${end}`;
        },

        async handleFileChange(event) {
            try {
                const files = event.target.files;
                const maxSize = this.maxSizeMB * 1024 * 1024; // Convert MB to bytes
                this.refresh = true;
                this.error = null;

                for (let i = 0; i < files.length; i++) {
                    if (files[i].size > maxSize) {
                        this.error = `File "${files[i].name}" exceeds the maximum allowed size of ${this.maxSizeMB}MB.`;
                        this.refresh = false;
                        this.selectedFiles = null; // Reset the file input
                        return;

                    }

                    const formData = new FormData();
                    formData.append('file', files[i]);
                    try {
                        const result = await uploadFile(formData); // Assuming this function returns the uploaded file info
                        this.$emit('file-uploaded', result); // Emit event for each successful upload
                    } catch (uploadError) {
                        this.selectedFiles = null; // Reset the file input  
                        msg.error(`Failed to upload "${files[i].name}". Please try again.`);
                    }
                }
            } catch (er) {
                this.error = er.message || 'An error occurred during file upload.';
                this.selectedFiles = null; // Reset the file input  
            } finally {
                this.refresh = false;
            }

        },
    },
    mounted() {
        if (this.initialFiles)
            this.file = this.initialFiles?.originalName


    }
};
</script>

<style scoped>
.input-file-component .d-style i,
.input-file-component .d-style-size {
    font-size: 9px;
    color: rgb(158 158 158);
    font-style: italic;
}

.input-file-component .title-table-file-upload {
    text-decoration-skip-ink: none;
    font-weight: 300;
}

.input-file-component .file-title {
    font-size: 12px;
    color: var(--primary);
    cursor: pointer;
}

.input-file-component .text-underline {
    text-decoration: underline;
}

.input-file-component .custom-file-label>span {
    color: #ccc !important;
}
</style>